module.exports = __webpack_public_path__ + "img/comment-smile.71abc31b.svg";